<template>
    <section v-if="!submitted">
        <h3>{{ $t('cloud_ai.feedback.title') }}</h3>
        <ul>
            <li v-for="option in options" :key="option.key">
                <reo-checkbox
                    v-model="option.checked"
                    :isRound="false"
                >
                </reo-checkbox>
                <div class="label">
                    {{ option.label }}
                </div>
            </li>
        </ul>
        <textarea
            v-model="feedbackText"
            :placeholder="$tc('cloud_ai.feedback.textPlaceholder')"
            maxlength="500"
            @focus="$emit('input-focus')"

        />
        <reo-common-button
            @click="submitFeedback"
            :label="$t('homepage.btnSubmit')"
            colorType="light"
            size="middle"
            :disabled="selectedOptions.length === 0"
        />
    </section>
    <div class="complete" v-else>
        <span class="icon icon-co_success_blue"><span class="path1"></span><span class="path2"></span></span>
        {{ $t('cloud_ai.feedback.complete') }}
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoCheckbox from './reoCheckbox.vue';
import { getFeedbackOptions, reportAiUsageFeedback } from '@/api/ai';
import { mapGetters } from 'vuex';
import { requestWithErrorHandler } from '@/common/js/utils';
import { TScene } from '@reolink-cloud/interface';
interface IOption {
    key: string;
    label: string;
    checked: boolean;
}

export default Vue.extend({
    components: {
        ReoCheckbox
    },
    props: {
        scene: {
            type: String,
            default: 'search'
        },
        userInput: Object
    },
    data() {

        return {
            options: [

            ] as IOption[],
            feedbackText: '',
            submitted: false
        };

    },
    computed:{
        ...mapGetters( ['lang'] as const ),
        currentLang(): string {

            const queryLang = this.$route.query.lang;
            if ( queryLang && typeof queryLang === 'string' ) {

                return queryLang;

            }

            return this.lang ;

        },
        currentScene(): TScene {

            const queryScene = this.$route.query.scene;
            if ( queryScene && typeof queryScene === 'string' ) {

                return queryScene as TScene;

            }

            return ( this.scene ?? 'search' ) as TScene;

        },
        selectedOptions(): string[] {

            return this.options.filter( option => option.checked ).map( option => option.key );

        }
    },
    async created() {

        const res = await getFeedbackOptions({
            scene: 'search',
            language:this.currentLang
        });
        const options: IOption[] = [];
        for ( const [key, value] of Object.entries( res.items )) {

            options.push({
                key,
                label: value,
                checked: false
            });

        }
        this.options = options;

    },
    methods: {
        async submitFeedback() {

            const selectedOptions = this.selectedOptions;
            await requestWithErrorHandler(() => reportAiUsageFeedback({
                scene: this.currentScene,
                options: selectedOptions,
                type: 'bad',
                userInput: {
                    ...( this.userInput ?? {})
                },
                content: this.feedbackText !== '' ? this.feedbackText : undefined
            }));
            this.submitted = true;

        }
    }
});
</script>

<style lang="less" scoped>
section{
    background-color: @bg_02;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    h3{
        font-size: 17px;
        font-weight: 500;
        line-height: 22px;
    }
    ul{
        display: flex;
        flex-direction: column;
        gap: 16px;
        li{
            font-size: 14px;
            line-height: 19px;
            display: flex;
            gap: 8px;
            align-items: center;
        }
    }
    textarea{
        background-color: @bg_01;
        border: none;
        outline: none;
        border-radius: @border-radius-level-button;
        font-size: 17px;
        padding: 15px;
        resize: vertical;
    }
}
.complete{
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    font-size: 20px;
    text-align: center;
    padding: 20px;
    .icon{
        font-size: 30px;
    }
}
</style>
